import { PRODUCTS, CATEGORIES } from "../data/products";

// ── helpers ──────────────────────────────────────────────────

function applyFilters(products, { category, brand, q, sort } = {}) {
  let list = [...products];

  if (category && category.toLowerCase() !== "all") {
    list = list.filter((p) => p.category === category);
  }
  if (brand && brand.toLowerCase() !== "all") {
    list = list.filter((p) => p.brand === brand);
  }
  if (q) {
    const lq = q.toLowerCase();
    list = list.filter(
      (p) =>
        p.name.toLowerCase().includes(lq) ||
        p.brand.toLowerCase().includes(lq) ||
        p.model_number.toLowerCase().includes(lq) ||
        p.short_description.toLowerCase().includes(lq)
    );
  }

  const sorters = {
    name_asc: (a, b) => a.name.localeCompare(b.name),
    name_desc: (a, b) => b.name.localeCompare(a.name),
    brand_asc: (a, b) => a.brand.localeCompare(b.brand) || a.name.localeCompare(b.name),
    newest: () => 0,
  };
  list.sort(sorters[sort] || sorters.name_asc);

  return list;
}

// ── public API (same signatures as before) ───────────────────

export const fetchProducts = async (filters = {}) => applyFilters(PRODUCTS, filters);

export const fetchCategories = async () => [...CATEGORIES];

export const fetchBrands = async () =>
  [...new Set(PRODUCTS.map((p) => p.brand))].sort();

// Inquiry submission — handled later; resolves silently for now.
export const submitInquiry = async (_payload) => ({ ok: true });
